import React, { useEffect, useState } from "react";
import { LineChart } from "@mui/x-charts";
import { FormControl, InputLabel, Select, MenuItem, Typography, Box, Stack, Divider } from "@mui/material";
import { MONTHS } from "../../Static/static";
import { DateTime} from "luxon"

const SessionsBChart = ({ data }) => {
  const [selectedMonth, setSelectedMonth] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  // Use a simple effect to initialize or reset data when props change
  useEffect(() => {
    const currentDate = DateTime.fromJSDate(new Date());
    if (data) {
      if (Number(currentDate.month)) {
        const month = MONTHS[currentDate.month-1];
        console.log(month)
        const filtered = data.filter(item => 
          item.month?.trim().toLowerCase() === month.trim().toLowerCase()
        );
        setSelectedMonth(month);
        setFilteredData(filtered);
      }
    } else {
      setFilteredData([]);
    }
  }, [data]);

  const handleChange = (event) => {
    const month = event.target.value;
    setSelectedMonth(month);
    if (!data || data === null) return;
    if (month) {
      // Filter the data by the selected month string
      const filtered = data.filter(item => 
        item.month?.trim().toLowerCase() === month.trim().toLowerCase()
      );
      setFilteredData(filtered);
    } else {
      // Reset to original dataset
      setFilteredData(data);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ mb: 1 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Box>
            <Typography variant="subtitle1" fontWeight="bold">Sessions & Attendance</Typography>
            <Typography variant="body2" color="text.secondary">
              {selectedMonth ? `Daily breakdown for ${selectedMonth}` : 'Monthly overview'}
            </Typography>
          </Box>

          <FormControl size="small" sx={{ minWidth: 150 }}>
            <InputLabel>Filter by Month</InputLabel>
            <Select
              value={selectedMonth}
              onChange={handleChange}
              label="Filter by Month"
            >
              <MenuItem value=""><em>All Months</em></MenuItem>
              {MONTHS.map((month) => (
                <MenuItem key={month} value={month}>{month}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
        <Divider sx={{ my: 1.5 }} />
      </Box>

      <Box sx={{ heigh: "100%", width: '100%'}}>
        <LineChart
            dataset={filteredData}
            height={300}
            xAxis={[{
              scaleType: 'band',
              // Dynamically switch key based on if a month is selected
              dataKey: selectedMonth ? 'session_date' : 'month', 
              tickLabelStyle: {
                angle: selectedMonth ? 0 : 0,
                textAnchor: selectedMonth ? 'start' : 'middle',
                fontSize: 11
              },
              valueFormatter: (value) => {
                if (selectedMonth) {
                  const date = DateTime.fromISO(value).toFormat("dd LLL yyyy")
                  return date.toString();
                }
              }

            }]}
            series={[
              {
                dataKey: 'total_sessions',
                label: 'Sessions',
                area: true,
                color: '#1976d2'
              },
              {
                dataKey: 'total_students',
                label: 'Total Students',
                color: '#2e7d32'
              },
              {
                dataKey: 'max_students',
                label: 'Max Attendance',
                color: '#ed6c02'
              }
            ]}
            margin={{ top: 70, right: 20, left: 50, bottom: 20 }}
            slotProps={{ 
              legend: filteredData.length > 0 ? {
                direction: 'row', 
                position: { vertical: 'top', horizontal: 'middle' }, 
                padding: -5 
              } : {
                hidden: true  // Hide legend when no data
              }
            }}
          />
      </Box>
    </Box>
  );
};

export default SessionsBChart;